import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-user-edit',
    templateUrl: './breadcrumb.user.edit.component.html'
})

export class BreadcrumbUserEditComponent { }
